import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { useLocale } from "../context/LocaleContext";
import { useRedirection } from "../context/RedirectionContext";
import { Grid, Collapse, Divider, Stack, Typography } from "@mui/material";
import DateFilter from "../components/Filters/DateFilter";
import AdvancedFilter from "../components/Filters/AdvancedFilter";
import TransactionItem from "../components/Transaction/TransactionItem";
import { TransitionGroup } from "react-transition-group";
import { CustomChip, CustomChipSelected, config } from "../components/Transaction/CustomChips";
import CustomButton from "../components/Base/CustomButton";
import TransactionItemLoader from "../components/Transaction/TransactionItemLoader";
import SearchBar from "../components/SearchBar";

import useTransactionStorage from "../hooks/useTransactionStorage";

const PAGESIZE = 50;

function groupByDate(transactions) {
	if (!Array.isArray(transactions)) {
		return {};
	}
	const sortedTransactions = transactions?.sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date));
	return sortedTransactions?.reduce((groups, transaction) => {
		const date = new Date(transaction.transaction_date).toLocaleDateString();
		if (!groups[date]) {
			groups[date] = [];
		}
		groups[date].push(transaction);
		return groups;
	}, {});
}

// function stringToUnixTime(dateStr, addOne = false) {
// 	// add one for mitigating timezone differences
// 	if (dateStr.toLocaleLowerCase() === 'dd/mm/yyyy') return null;
// 	const arr = dateStr.split('/');
// 	return new Date(arr[2], arr[1] - 1, String(Number(arr[0]) + (addOne ? 1 : 0))).getTime();
// }

export default function TransactionsPage() {
	const { redirectionData, setRedirection } = useRedirection();
	const { messages } = useLocale();
	const start = useRef(null);
	const end = useRef(null);
	const [search, setSearch] = useState('');
	const [types, setTypes] = useState('');

	const [renderedData, setRenderedData] = useState();
	const [loaded, setLoaded] = useState(false);
	const [groupedTransactions, setGroupedTransactions] = useState({});
	const [expanded, setExpanded] = useState();

	const [transaction, dispatch] = useTransactionStorage("transaction", []);

	const redirectionSearch = (date, type) => {
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/transaction/search_transaction/MUM1957MH/?` + [
					`page=${1}`,
					`page_size=${PAGESIZE}`,
					search !== '' ? `text=${search}` : null,
					type.length ? `transaction_type=${type[0]}` : null,
					date ? `transaction_date_start=${date}` : null,
					end.current?.value ? `transaction_date_end=${end.current?.value}` : null,
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					data.forEach(item => {
						dispatch({ type: 'ADD', payload: item });
					});
					setRenderedData(data);
					setGroupedTransactions(groupByDate(data));
				}
				else {
					setRenderedData([]);
					setGroupedTransactions(groupByDate([]));
				}
			}
			setLoaded(true);
		}
		setLoaded(false);
		getData();
		setRedirection({});
	}

	const voiceSearch = (searchStr) => {
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/transaction/search_transaction/MUM1957MH/?` + [
					`page=${1}`,
					`page_size=${PAGESIZE}`,
					searchStr !== '' ? `text=${searchStr}` : null,
					types !== '' ? `transaction_type=${types}` : null,
					start.current?.value ? `transaction_date_start=${start.current?.value}` : null,
					end.current?.value ? `transaction_date_end=${end.current?.value}` : null,
					'audio=true',
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					data.forEach(item => {
						dispatch({ type: 'ADD', payload: item });
					});
					setRenderedData(data);
					setGroupedTransactions(groupByDate(data));
				}
				else {
					setRenderedData([]);
					setGroupedTransactions(groupByDate([]));
				}
			}
			setLoaded(true);
		}
		setLoaded(false);
		getData();
		setRedirection({});
	}

	const doApiSearch = () => {
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/transaction/search_transaction/MUM1957MH/?` + [
					`page=${1}`,
					`page_size=${PAGESIZE}`,
					search !== '' ? `text=${search}` : null,
					types !== '' ? `transaction_type=${types}` : null,
					start.current?.value ? `transaction_date_start=${start.current?.value}` : null,
					end.current?.value ? `transaction_date_end=${end.current?.value}` : null,
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					data.forEach(item => {
						dispatch({ type: 'ADD', payload: item });
					});
					setRenderedData(data);
					setGroupedTransactions(groupByDate(data));
				}
				else {
					setRenderedData([]);
					setGroupedTransactions(groupByDate([]));
				}
			}
			setLoaded(true);
		}
		setLoaded(false);
		getData();
		setRedirection({});
	}

	// const handleSubmit = () => {
	// 	if (loaded) {
	// 		console.log(start.current.value);
	// 		const startDate = start.current.value ? stringToUnixTime(start.current.value) : null;
	// 		const endDate = end.current.value ? stringToUnixTime(end.current.value, true) : null;
	// 		const filteredData = transaction.filter(transaction => {
	// 			const transactionDate = new Date(transaction.date).getTime();
	// 			const isTypeMatch = types.length > 0 ? types.includes(transaction.type) : true;
	// 			const isStartDateMatch = startDate ? transactionDate >= startDate : true;
	// 			const isEndDateMatch = endDate ? transactionDate <= endDate : true;
	// 			return isTypeMatch && isStartDateMatch && isEndDateMatch;
	// 		});
	// 		setRenderedData(filteredData);
	// 	}
	// };

	const handleTypeChange = (newType) => {
		if (types === newType) {
			setTypes('');
		}
		else {
			setTypes(newType);
		}
	}

	useEffect(() => {
		setLoaded(false);
		const getData = async () => {
			const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/transaction/view_transaction/MUM1957MH/?page=1&page_size=${PAGESIZE}`, {
				method: "GET",
				headers: {
					"Content-Type": "appliation/json",
				},
			})
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data;
					data.forEach(item => {
						dispatch({ type: 'ADD', payload: item });
					});
					setRenderedData(data);
					setGroupedTransactions(groupByDate(data));
				}
			}
		}
		console.log(redirectionData);
		if (redirectionData && redirectionData.path === "/transactions") {
			const date = redirectionData.data.duration ? (new Date(Date.now() - Number(redirectionData.data.duration * 1000 * 60 * 60 * 24)).toLocaleString("en-IN")).split(",")[0] : null;
			console.log(date);
			setTypes(redirectionData.data.filters);
			redirectionSearch(date, redirectionData.data.filters);
		}
		else {
			getData();
		}

		setLoaded(true);
	}, [])

	useEffect(() => {
		if (redirectionData && redirectionData.path === "/transactions") {
			const date = redirectionData.data.duration ? (new Date(Date.now() - Number(redirectionData.data.duration * 1000 * 60 * 60 * 24)).toLocaleString("en-IN")).split(",")[0] : null;
			console.log(redirectionData.data.filters)
			setTypes(redirectionData.data.filters);
			redirectionSearch(date, redirectionData.data.filters);
		}
	}, [redirectionData])

	useEffect(() => {
		if (loaded) {
			setGroupedTransactions(groupByDate(renderedData));
		}
	}, [loaded, renderedData])

	return (
		<>
			<SearchBar searchString={search} setSearchString={setSearch} placeholder={messages.inventory.search.placeholder} doApiSearch={doApiSearch} voiceSearch={(search) => voiceSearch(search)} />
			<AdvancedFilter>
				<Grid container rowGap={2} mb={4}>
					<Grid item xs={6}>
						<DateFilter label={messages.transaction.filters.startDate} ref={start} />
					</Grid>
					<Grid item xs={6}>
						<DateFilter label={messages.transaction.filters.endDate} ref={end} />
					</Grid>
					<Grid item xs={12} md={6}>
						<Stack justifyContent='space-evenly' flexDirection='row' flexWrap='wrap'>
							{Object.keys(config).map((type, i) => (
								React.cloneElement(types === type ? <CustomChip /> : <CustomChipSelected />, { ...config[type], label: messages.transaction.chips[type], onClick: () => handleTypeChange(type), key: i })
							))}
						</Stack>
					</Grid>
					<Grid item xs={12} md={6} p="5px">
						<CustomButton fullWidth onClick={() => doApiSearch()}>{messages.common.submit}</CustomButton>
					</Grid>
				</Grid>
			</AdvancedFilter>
			<TransitionGroup>
				{loaded ?
					(renderedData?.length !== 0 ?
						Object.keys(groupedTransactions).map(date => (
							<Collapse key={date} sx={{ marginBottom: '12px' }}>
								<Divider variant="middle" sx={{ marginBottom: '12px' }}>{date}</Divider>
								<TransitionGroup>
									{groupedTransactions[date].map(e => (
										<Collapse key={e.transaction_id}>
											<TransactionItem {...e} setExpanded={() => setExpanded(expanded === e.transaction_id ? null : e.transaction_id)} expanded={expanded === e.transaction_id} label={messages.transaction.chips[e.transaction_type]} />
										</Collapse>
									))}
								</TransitionGroup>
							</Collapse>
						))
						:
						<Typography fullWidth textAlign="center" variant="h5" style={{ marginTop: '20px'}}>Data Not Found</Typography>
					)
					:
					Array.from({ length: 20 }, (e, i) =>
						<Collapse key={i} sx={{ marginBottom: '12px' }}>
							<TransactionItemLoader />
						</Collapse>
					)
				}
			</TransitionGroup>
		</>
	)
}